<div class="login-container d-flex flex-column align-items-center gap-3">
    <div class="wsm-branding d-flex flex-column align-items-center gap-1">
        <img src="assets/images/svg-icons/wsm-coin.svg" alt="wsm-coin-img">
        <h4 class="m-0">WSM</h4>
        <h2 class="m-0">CASINO</h2>
    </div>
    <form [formGroup]="loginForm" class="d-flex flex-column gap-3">
        <div class="login-input-field">
            <label for="email">Email</label>
            <input type="text" name="email" formControlName="email" placeholder="Email">
            <span *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.hasError('required')"
                class="error-text">Email is required</span>
            <span *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.hasError('pattern')"
                class="error-text">Please enter a valid email</span>
        </div>
        <div class="login-input-field">
            <label for="password">Password</label>
            <div class="password-field">
                <input [type]="hidePassword ? 'password' : 'text'" name="password" formControlName="password"
                    placeholder="Password">
                <span *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.hasError('required')"
                    class="error-text">Password is required</span>
                <img [src]="hidePassword ? 'assets/images/svg-icons/eye-password-hide.svg' : 'assets/images/svg-icons/eye-password-show.svg'"
                    alt="eye" (click)="hidePassword = !hidePassword">
            </div>
        </div>
        <div class="action-btn-section d-flex flex-row justify-content-center align-items-center ">
            <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid || wrongPassword"
                (click)="login()">Login</button>
        </div>
    </form>
</div>